<script setup lang="ts">
import {
  BoxComponent,
  COMMON_RESET_PAGE_ON,
  commonFilterFields,
  type ContentItemsFilter,
  PageWrapperComponent,
  useQueryFilter,
} from '@metapic-apps/shared'
import { computed, watch } from 'vue'

import ContentLibraryGrid from '@/components/ContentLibrary/ContentLibraryGrid.vue'
import ContentLibraryMediaFilters from '@/components/ContentLibrary/ContentLibraryMediaFilters.vue'
import { useAdvertiserStore } from '@/stores/advertiser.stores'
import { useGlobalFilterStore } from '@/stores/global-filter.stores'

const advertiserStore = useAdvertiserStore()
const advertiser = computed(() => advertiserStore?.advertiser)
const filterStore = useGlobalFilterStore()
const { filter } = useQueryFilter<ContentItemsFilter>(
  {
    page: commonFilterFields.page,
    sortBy: commonFilterFields.sortBy,
    creator: commonFilterFields.creator,
    campaign: commonFilterFields.campaign,
    contentTypes: commonFilterFields.contentTypes,
  },
  {
    page: 1,
    sortBy: 'date:desc',
  },
  { resetPageOn: COMMON_RESET_PAGE_ON },
)
const applyGlobalDateRange = () => {
  filter.value = {
    ...filter.value,
    dateFrom: filterStore.dateRange?.startDate,
    dateTo: filterStore.dateRange?.endDate,
  }
}
watch(() => filterStore.dateRange, applyGlobalDateRange, { deep: true, immediate: true })
</script>

<template>
  <BoxComponent :pl="24" :pr="24">
    <main>
      <PageWrapperComponent>
        <BoxComponent :mb="32">
          <ContentLibraryMediaFilters v-model="filter" />
        </BoxComponent>
        <ContentLibraryGrid v-model="filter" :advertiser="advertiser" />
      </PageWrapperComponent>
    </main>
  </BoxComponent>
</template>
